import { lazyLoad } from 'utils/loadable';

export const WellPlannerPage = lazyLoad(
  () => import('app/components/pages/WellPlannerPage/index'),
  (module) => module.WellPlannerPage,
);
